import React from 'react';

import WaveformBar from 'js/src/components/app/waveform/WaveformBar';
import type { ImmutableWaveformData } from 'js/src/data/media';

const WAVEFORM_SPACE_BETWEEN_BARS = 0.75;

type WaveformBarGroupPresentationProps = {
    waveformData: ImmutableWaveformData;
    svgWidth: number;
    svgHeight: number;
    fillPercentage: number;
};

const WaveformBarGroupPresentation = ({
    waveformData,
    svgWidth,
    svgHeight,
    fillPercentage,
}: WaveformBarGroupPresentationProps) => {
    const maxVolume = waveformData.max();
    const barWidth = svgWidth / waveformData.size;
    const fillToX = (svgWidth * fillPercentage) / 100;
    if (maxVolume === undefined) return null;
    return (
        <g>
            {waveformData.map((volume, i) => {
                const rectWidth = Math.max(barWidth - WAVEFORM_SPACE_BETWEEN_BARS, 0);
                const rectHeight = maxVolume > 0 ? (volume / maxVolume) * svgHeight : 0;
                const rectX = i * barWidth + WAVEFORM_SPACE_BETWEEN_BARS / 2; // move over "i" times, and then add half the padding of SPACE_BETWEEN_BARS
                const rectY = Math.max(svgHeight - rectHeight, 0);
                const rectShaded = rectX < fillToX;
                return (
                    <WaveformBar
                        key={i}
                        x={rectX}
                        y={rectY}
                        width={rectWidth}
                        height={rectHeight}
                        shaded={rectShaded}
                    />
                );
            })}
        </g>
    );
};

const WaveformBarGroupMemoized = React.memo(WaveformBarGroupPresentation);
const WaveformBarGroup = WaveformBarGroupMemoized;

export default WaveformBarGroup;
